/**
 * How well one viewer's connection keeps up, as 1 to 4 bars.
 *
 * The measure is the viewer's own bandwidth estimate against the bitrate the
 * host asked for: a path that carries the whole stream is four bars, one that
 * can only carry a third of it is one. No estimate yet means nothing is known
 * to be wrong, so it reads as full rather than alarming a viewer who just
 * joined.
 */
import { t } from './i18n.svelte'

export type Bars = 1 | 2 | 3 | 4

export function barsFor(estimateKbps: number | null | undefined, ceilingKbps: number): Bars {
  if (estimateKbps == null || ceilingKbps <= 0) return 4
  const ratio = estimateKbps / ceilingKbps
  if (ratio >= 0.9) return 4
  if (ratio >= 0.6) return 3
  if (ratio >= 0.35) return 2
  return 1
}

export function barsLabel(bars: number): string {
  return t(
    ['', 'Poor connection', 'Weak connection', 'Good connection', 'Great connection'][bars] ?? '',
  )
}
